'use client'

import { Pencil, ScrollText } from 'lucide-react'

import { useAutomations } from '~/app/automations/useAutomations'
import { AutomationPolicyDisplay } from '~/components/automations/AutomationPolicyDisplay'
import { TriggerAutomationButton } from '~/components/automations/TriggerAutomationButton'
import { Button } from '~/components/component-library'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { useAuth } from '~/context/AuthProvider'
import { useNavigation } from '~/hooks/useNavigation'

export const AutomationActionButtons = ({
  smartAccountId,
  isDisabled,
}: {
  smartAccountId: string
  isDisabled?: boolean
}) => {
  const { automations, isLoading } = useAutomations()
  const automation = automations.find(
    (a) => a.smartAccountId === smartAccountId,
  )
  const { setGlobalModalState } = useAuth()
  const navigate = useNavigation()

  if (!automation && !isLoading) return null

  const buttonsDisabled = isDisabled || !automation

  return (
    <>
      <Button
        variant="secondary"
        prefix={<ScrollText className="w-4" />}
        isDisabled={buttonsDisabled}
        onClick={() => {
          if (!automation) return
          setGlobalModalState({
            isOpen: true,
            content: (
              <SplitsDialogContent
                id="automationPolicy"
                title="Policy"
                variant="info"
              >
                <AutomationPolicyDisplay policy={automation.policy} />
              </SplitsDialogContent>
            ),
          })
        }}
      >
        Policy
      </Button>
      <Button
        variant="secondary"
        prefix={<Pencil className="w-4" />}
        isDisabled={buttonsDisabled}
        onClick={() => {
          if (!automation) return
          navigate(`/automations/${automation.id}/edit`)
        }}
      >
        Edit
      </Button>
      <TriggerAutomationButton
        automation={automation}
        isDisabled={isDisabled}
      />
    </>
  )
}
